import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { SWIMLANES_TYPES } from '@results/constants';
import {
  SCREEN_TYPES,
  SWIMLANE_TYPES as TRACK_SWIMLANES_TYPES,
} from '@results/tracking/actions/trackSwimlaneClicked';

function SwimlaneCardContainer({
  children,
  shopId,
  onClick,
  trackSwimlaneClicked,
  swimlane,
  swimlanePosition,
  item,
  positionItem,
}) {
  const handleClick = useCallback(
    (...params) => {
      const type =
        swimlane?.type === SWIMLANES_TYPES.PARTNERS
          ? TRACK_SWIMLANES_TYPES.PARTNER
          : TRACK_SWIMLANES_TYPES.PRODUCT;

      const itemId = item?.productId || item?.id;

      trackSwimlaneClicked({
        shopId: shopId || item?.restaurantId || item?.id,
        swimlaneTitle: swimlane?.code,
        swimlanePosition,
        swimlaneType: swimlane?.type || type,
        productSku: itemId,
        positionItem: positionItem + 1,
        screenType: shopId ? SCREEN_TYPES.SHOP_DETAIL : SCREEN_TYPES.VERTICAL,
      });

      if (onClick) onClick(...params);
    },
    [
      item,
      onClick,
      positionItem,
      shopId,
      swimlane,
      swimlanePosition,
      trackSwimlaneClicked,
    ],
  );

  return children(handleClick);
}

SwimlaneCardContainer.defaultProps = {
  swimlanePosition: 0,
};

SwimlaneCardContainer.propTypes = {
  // calling component
  children: PropTypes.func.isRequired,
  swimlane: PropTypes.object.isRequired,
  swimlanePosition: PropTypes.number,
  item: PropTypes.object.isRequired,
  positionItem: PropTypes.number.isRequired,
  onClick: PropTypes.func,

  // redux
  shopId: PropTypes.number,
  trackSwimlaneClicked: PropTypes.func.isRequired,

  // withRouter
  match: PropTypes.shape({
    params: PropTypes.shape({
      city: PropTypes.string,
      restaurant: PropTypes.string,
    }),
  }).isRequired,
};

export default withRouter(SwimlaneCardContainer);
